import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import FormGroup from '@material-ui/core/FormGroup';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

const styles = theme => ({
	contentText:{
		marginBottom:15
	},
	fromTo : {
		padding: '9px 15px 0 15px',
		fontSize: '1.5rem',
		fontFamily: "Roboto, Helvetica, Arial, sans-serif",
		boxSizing:'border-box'
	},
	inputText : {
		flexGrow : 1
	}
});

function Transition(props) {
	return <Slide direction="up" {...props} />;
}

const updateHashBase = {from:'',to:''};

class formDialog extends React.Component {
	
	constructor(props) {
		super(props);
		const conversion = (!props.conversion.length) ? [updateHashBase] : props.conversion;
		this.state = {
			conversion : conversion
		}
	}

	UNSAFE_componentWillReceiveProps(nextProps){
		if(nextProps.open !== this.props.open){
			const conversion = (!nextProps.conversion.length) ? [updateHashBase] : nextProps.conversion;
			this.setState({
				conversion : conversion
			});
		}
	}

	/** event handlers **/

	handleClose = () =>{
		const {afterCancelFunc} = this.props;
		if(afterCancelFunc) afterCancelFunc();
	};



	render () {
		const {open, classes} = this.props;
		const {conversion} = this.state;

		const inputRow = (conv, index) =>{
			const fromValue = !(conv) || !("from" in conv) || !(conv.from) ? '' : conv.from;
			const toValue = !(conv) || !("to" in conv) || !(conv.to) ? '' : conv.to;

			return(
				<FormGroup row key={index}>
					<TextField
						margin="dense"
						label="変換前"
						value={fromValue}
						className={classes.inputText}
						InputProps={{
							readOnly: true,
						}}
					/>
					<div className={classes.fromTo}>-</div>
					<TextField
						margin="dense"
						label="変換後"
						value={toValue}
						className={classes.inputText}
						InputProps={{
							readOnly: true,
						}}
					/>
				</FormGroup>
			)
		};

		return (
			<Dialog
				open={open}
				onClose={this.handleClose}
				aria-labelledby="form-dialog-title"
				TransitionComponent={Transition}
				keepMounted
				fullWidth
				maxWidth={'sm'}
			>
				<DialogTitle id="form-dialog-title">データ変換設定</DialogTitle>
				<DialogContent>
					<DialogContentText>
						設定されたデータ変換設定を確認してください
					</DialogContentText>
					{conversion.map((conv,index)=>{
						return(
							inputRow(conv,index)
						)
					})}
				</DialogContent>
				<DialogActions>
					<Button onClick={this.handleClose} color="primary">
						OK
					</Button>
				</DialogActions>
			</Dialog>

		);
	}
}
formDialog.propTypes = {
	conversion : PropTypes.array,
	open : PropTypes.bool,
	afterCancelFunc : PropTypes.func
};
formDialog.defaultProps = {
	conversion : []
};
export default withStyles(styles)(formDialog);



// WEBPACK FOOTER //
// ./src/routes/mapping/step4/components/form-dialog.js